import React from 'react'

import {Flex} from '@daedalus/atlas/helpers/Flex'
import {Tag} from '@daedalus/atlas/Tag'
import {Text} from '@daedalus/atlas/Text'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

interface Props {
  isOnlySplitBookingOfferAvailable?: boolean
  savingPercentage?: number
}

export const SplitBookingCardHeader = ({
  isOnlySplitBookingOfferAvailable = false,
  savingPercentage
}: Props) => {
  return (
    <Flex.Row gap="s300" alignItems="flex-end">
      <Flex.Column gap="s100">
        {isOnlySplitBookingOfferAvailable ? (
          <Text
            variant="titleS"
            colorPath="content.success.c500"
            dataId="vioExclusiveTitle"
          >
            <FormattedMessageWrapper
              id="splitBooking.vioExclusiveTitle"
              defaultMessage="Vio.com exclusive"
            />
          </Text>
        ) : null}
        <Text variant="titleL">
          {isOnlySplitBookingOfferAvailable ? (
            <FormattedMessageWrapper
              id="splitBooking.onlyOfferCardTitle"
              defaultMessage="Switch rooms to stay here"
              dataId="splitBooking.onlyOfferCardTitle"
            />
          ) : (
            <FormattedMessageWrapper
              id="switchRoomsAndSave"
              defaultMessage="Switch rooms and save"
              dataId="splitBooking.cardTitle"
            />
          )}
        </Text>
      </Flex.Column>
      {Boolean(savingPercentage && savingPercentage > 0) && (
        <Tag variant="success" size="sm" dataId="splitBooking.savingTag">
          <FormattedMessageWrapper
            id="splitBooking.saveTagOff"
            defaultMessage="-{savingPercentage}% off"
            values={{
              savingPercentage
            }}
          />
        </Tag>
      )}
    </Flex.Row>
  )
}
